import React, { useRef, useState } from "react";
const klavioListId = process.env.GATSBY_KLAVIYO_LIST_ID;

const Subscribe = ({ subscribeHeadline = "" }) => {
  const emailRef = useRef(null);
  const [success, setSuccess] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    const email = emailRef.current?.value;

    const data = {
      g: klavioListId,
      email: email ?? "",
    };

    const urlData = new URLSearchParams(data);
    fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: "POST",
      body: urlData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.is_subscribed) {
          setSuccess(data.data.is_subscribed);
        }
      })
      .catch((error) => console.error("Error ---> ", error));
  };

  return (
    <div className="max-w-[1000px] relative w-full px-5 xl:pl-[90px] pb-[60px] z-[1] pt-10 md:pt-0">
      <h2 className="text-xl md:text-3xl mb-[10px] md:mb-[30px] pb-[10px] md:pb-5 font-bold leading-[30px] md:leading-[45px] tracking-wide">
        Subscribe
      </h2>
      {!success ? (
        <div className="flex gap-x-2 gap-y-5 w-full flex-wrap pt-5">
          <p className="w-full md:w-[45%]">{subscribeHeadline}</p>
          <form className="flex md:mt-[10px]" onSubmit={onSubmit}>
            <input
              className="w-full max-w-[190px] text-white tracking-wide outline-none border-b border-solid border-b-white/60 placeholder:text-[#f2f2f2]
              placeholder:opacity-60 placeholder:font-light bg-transparent appearance-none rounded-none"
              placeholder="Email address"
              type="email"
              ref={emailRef}
              required
            />
            <button
              type="submit"
              className="bg-white text-black w-[160px] h-10 ml-5 rounded-full border-none outline-none font-semibold leading-4 text-center"
            >
              Sign up
            </button>
          </form>
        </div>
      ) : (
        <div className="flex gap-2 w-full flex-wrap">
          <p className="w-full md:w-[45%]">
            Thanks for subscribing, you will receive an email in your inbox soon
          </p>
        </div>
      )}
    </div>
  );
};

export default Subscribe;
